import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Manufacturing_ds_get_manufacturing_orders_for_calendarService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { start_of_day: string, end_of_day: string, order_status?: number }): 
  Promise<{ result: { Id?: number, ActualCompleteOn?: string, ActualStartOn?: string, DefaultStagingLocationId?: number, EstimatedCompleteOn?: string, EstimatedStartOn?: string, LookupCode?: string, ManufacturingLocationId?: number, ProjectId?: number, StatusId?: number, WarehouseId?: number, OrderLines?: { Id?: number, PackagedAmount?: number, Material?: { Name?: string }, Tasks?: { ActualPackagedAmount?: number, OperationCodeId?: number }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.start_of_day)) {
      missingRequiredInParams.push('\'start_of_day\'');
    }
    if (isNil(inParams.end_of_day)) {
      missingRequiredInParams.push('\'end_of_day\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_orders_for_calendar/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { start_of_day: string, end_of_day: string, order_status?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualCompleteOn?: string, ActualStartOn?: string, DefaultStagingLocationId?: number, EstimatedCompleteOn?: string, EstimatedStartOn?: string, LookupCode?: string, ManufacturingLocationId?: number, ProjectId?: number, StatusId?: number, WarehouseId?: number, OrderLines?: { Id?: number, PackagedAmount?: number, Material?: { Name?: string }, Tasks?: { ActualPackagedAmount?: number, OperationCodeId?: number }[] }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.start_of_day)) {
      missingRequiredInParams.push('\'start_of_day\'');
    }
    if (isNil(inParams.end_of_day)) {
      missingRequiredInParams.push('\'end_of_day\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_orders_for_calendar/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { start_of_day: string, end_of_day: string, order_status?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualCompleteOn?: string, ActualStartOn?: string, DefaultStagingLocationId?: number, EstimatedCompleteOn?: string, EstimatedStartOn?: string, LookupCode?: string, ManufacturingLocationId?: number, ProjectId?: number, StatusId?: number, WarehouseId?: number, OrderLines?: { Id?: number, PackagedAmount?: number, Material?: { Name?: string }, Tasks?: { ActualPackagedAmount?: number, OperationCodeId?: number }[] }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.start_of_day)) {
      missingRequiredInParams.push('\'start_of_day\'');
    }
    if (isNil(inParams.end_of_day)) {
      missingRequiredInParams.push('\'end_of_day\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Manufacturing/datasources/ds_get_manufacturing_orders_for_calendar/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      start_of_day: string, end_of_day: string, order_status?: number    }) {
        if(isNil(inParams.start_of_day)) {
          return true; 
        }
        if(isNil(inParams.end_of_day)) {
          return true; 
        }
      return false;
    }
}
